// extracted by mini-css-extract-plugin
export default {"dots":"DotLoader_dots__nVRor","dots-7ar3yq":"DotLoader_dots-7ar3yq__7LSLd"};